import { Injectable } from '@angular/core';
import { ApiNameList } from 'src/environments/api-name-list';
import { HttpClientService } from '../../services/http-client-service';

@Injectable()
export class SaeRegistrationService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    createUser(request: {emailAddress: string, usrSecret: string, studentId: number, dateOfBirth: string, participationId: string}) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.createUser, request);
    }
    
    createMicrositeUser(request: {emailAddress: string, usrSecret: string, studentId: string, dateOfBirth: string, micrositeId: string, storyId: string}) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.createMicrositeUser, request);
    }
}   




